import { localStore } from '@dt/fe-utils'
import { filter, forEach, keyBy } from '@dt/fe-utils/dist/lodash'
import { makeAutoObservable } from 'mobx'
import { restaurantConfig, storeMobx, cartMobx } from 'restaurant'
import { getViewItems } from 'restaurant/mobx/cart.mobx'

/** 预点单，非排队 */
class PreOrderingMobx {
  constructor () {
    makeAutoObservable(this)
  }
  cacheCart: ICartCopy
  cartItems: ICartItem[] = []

  /** productNo为key统计加入购物车的数量 */
  get noToCartItemsCntMap () {
    const map = {}
    forEach([...this.cartItems, ...cartMobx.cartItems], (item) => {
      map[item.productNo] = (map[item.productNo] || 0) + item.cnt
    })
    return map
  }
  /** 用于展示的 */
  get viewItems () {
    return getViewItems(this.cartItems, { cntMap: this.noToCartItemsCntMap })
  }
  /** 不可用的餐品disabled */
  get pkTodisableItemsMap () {
    return keyBy(this.viewItems, 'pk')
  }
  /** 判断是否是预点单 在门店码下需要判断 */
  get checkPreOrder () {
    return Config.codeType === 'store' && Config.isPreOrder
  }

  get hasPreOrder () {
    return this.cartItems.length
  }
  /**
   * 桌码场景下同步预点单
   */
  addToCart () {
    const cartItems = filter(this.cartItems, (item) => !this.pkTodisableItemsMap?.[item.pk]?.disabled)
    cartMobx.setCartItems([...cartMobx.cartItems, ...cartItems], true)
    this.clearCart()
  }

  /** 桌码下初始化预下单数据 */
  initTablePreOrder () {
    const storeId = storeMobx.info.storeId || restaurantConfig.storeId || 0
    Config.codeType === 'table' && storeId && this.getCart(storeId)
  }

  /**
   * 门店码预下单
   */
  /** 同步本地预下单购物车到代码 */
  setCacheCartToCart () {
    if (this.checkPreOrder) {
      const storeId = storeMobx.info.storeId || restaurantConfig.storeId || 0
      const Cart = this.getCart(storeId)
      // payMode: 扫桌码通过桌码判断payMode值， 如果是品牌码或者店码都是先付费 cartMobx.reset()
      if (Cart) {
        // 如果存在购物车
        cartMobx.restoreByCopy(Cart, false)
      } else {
        // 不存在缓存数据，清除上一家门店遗留购物车数据
        cartMobx.clear()
      }
    }
  }

  setCart () {
    const storeId = restaurantConfig.storeId
    if (storeId) {
      const cartInfo = localStore.get('cart.cache.preOrder') || {}
      cartInfo[storeId] = cartMobx.getCopy(false)
      localStore.set('cart.cache.preOrder', cartInfo)
    }
  }

  /** 获取本地购物车 */
  getCart (storeId: number) {
    const curCart = localStore.get('cart.cache.preOrder') && localStore.get('cart.cache.preOrder')[storeId.toString()] || false
    if (curCart && curCart.createTime + 12 * 60 * 60 * 1000 > Date.now()) {
      this.cartItems = curCart.cartItems
      this.cacheCart = curCart
      return curCart
    } else {
      if (curCart.createTime + 12 * 60 * 60 * 1000 < Date.now()) {
        localStore.remove('cart.cache.preOrder')
      }
    }
    return null
  }

  /** 清除本地缓存购物车 */
  clearCart () {
    const storeId = restaurantConfig.storeId
    if (storeId) {
      const cartInfo = localStore.get('cart.cache.preOrder') || {}
      delete cartInfo[storeId]
      localStore.set('cart.cache.preOrder', cartInfo)
      this.cartItems = []
      this.cacheCart = null
    }
  }
}

export default new PreOrderingMobx()
